import * as FilterActions from '../actions/filter.action'
import { IServerSideGetRowsRequest } from '@ag-grid-community/core';
import { isEqual } from 'lodash';
import { IFilterProfile } from 'src/app/interfaces/tankProfile';

//Filtered Rows - Batched and saved when Grid GetRows IServerSideDataSource:GetRows()
const initialFilterProfileState: IFilterProfile = null;
const initialFilterProfilesState: IFilterProfile[] = [];  
export function filterReducer(state: IFilterProfile = initialFilterProfileState, action: FilterActions.Actions) {
  switch (action.type) {
    case FilterActions.CHANGE_FILTER_PROFILE:
      return action.payload;
    default:
      return state;
  }
}

//Filtered request object used by ag-grids. This is passed to query tank grid data by other page components
const initialGridFilterState: IServerSideGetRowsRequest = {
  endRow: 100,
  filterModel: null,
  groupKeys: [],
  pivotCols: [],
  pivotMode: false,
  rowGroupCols: [],
  sortModel: [],
  startRow: 0,
  valueCols: [],
};


export function gridFilterReducer(state: IServerSideGetRowsRequest = initialGridFilterState, action: FilterActions.Actions) {
  switch (action.type) {
    case FilterActions.CHANGE_TANK_GRID_REQUEST:
      {
        //deep compare the grid Filter model to the previous one. If they are the same, don't update the state.
        //do not use JSON.stringify() to compare the objects. It will fail if the order of the properties are different.
        //use lodash isEqual() instead.
        //debugger;
        const {source, ...oldState} = state as any; //remove the source property from the state object
        const newState = action.payload;
        if(!isEqual(oldState, newState))
          return {...newState, source: action.source};

        return state;
      }
    case FilterActions.CHANGE_TANK_FILTER: //Change only the filterModel property of the state object
      {
        const {filterModel} = state as any;
        if(!isEqual(filterModel, action.payload)) {
          //merge the filterModel property of the state object with the new filterModel
          const newState = {...state, filterModel: action.payload, source: action.source}
          return newState;
        }

        return state;

      }
    case FilterActions.SHOW_ALL_GATEWAYS:
      {
          const showAllGateways = action.payload; 
          const newState = {...state, includeAllGateways: showAllGateways};
          return newState;
      }
    default:
      return state;
  }
}

export function filteredTanksReducer(state: any[] = [], action: FilterActions.Actions){
  switch (action.type) {
    case FilterActions.LOAD_PREVIOUSLY_SELECTED_TANKS:
        return action.payload;
    case FilterActions.UPDATE_SELECTED_TANKS:
        return action.payload;
    default:
      return state;
  }
}

export function filterProfilesReducer(state: IFilterProfile[] = initialFilterProfilesState, action: FilterActions.Actions) {
  switch (action.type) {
    case FilterActions.SET_FILTER_PROFILES:
      return action.payload;
    default:
      return state;
  }
}

// export function tankGridChangeReducer(state: any[], action: FilterActions.Actions) {
//   switch (action.type) {
//     case FilterActions.TANK_GRID_CHANGE:
//       return action.payload;
//     default:
//       return state;
//   }
// }

